export function IsPageWithLocale(path) {
    if(path === "" && window.location.pathname === "/") {
        return true
    }

    return window.location.pathname === path || window.location.pathname  === "/pl" + path || window.location.pathname === "/es" + path
}